const API = window.RFAPI
export default API
